document.addEventListener('DOMContentLoaded', () => {
  const openCart = () => document.body.classList.add('cart-open');
  const closeCart = () => document.body.classList.remove('cart-open');

  const updateCartCount = itemCount => {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = itemCount;
    });
  };

  const refreshCartDrawer = async () => {
    const response = await fetch('/cart', {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!response.ok) return;

    const html = await response.text();
    const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
    const freshDrawer = parsedDocument.querySelector('.cart-drawer');
    const freshOverlay = parsedDocument.querySelector('.cart-drawer-overlay');
    const currentDrawer = document.querySelector('.cart-drawer');
    const currentOverlay = document.querySelector('.cart-drawer-overlay');

    if (freshOverlay && currentOverlay) currentOverlay.replaceWith(freshOverlay);
    if (freshDrawer && currentDrawer) currentDrawer.replaceWith(freshDrawer);
  };

  document.addEventListener('click', event => {
    if (event.target.closest('[data-cart-open]')) {
      event.preventDefault();
      openCart();
    }

    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeCart();
    }

    const clearCartButton = event.target.closest('[data-cart-clear]');
    if (clearCartButton) {
      const wantsToClear = window.confirm('¿Quieres vaciar tu carrito?');
      if (!wantsToClear) event.preventDefault();
    }
  });

  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const originalText = button ? button.textContent : '';
      if (button) {
        button.textContent = 'Agregando...';
        button.disabled = true;
      }

      try {
        const formData = new FormData(form);
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        });

        if (!addResponse.ok) throw new Error('No se pudo agregar el producto.');

        const cart = await fetch('/cart.js', {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { 'Accept': 'application/json' }
        }).then(r => r.json());

        updateCartCount(cart.item_count);
        await refreshCartDrawer();
        openCart();
      } catch (error) {
        alert('No se pudo agregar al carrito. Revisa la variante seleccionada.');
      } finally {
        if (button) {
          button.textContent = originalText;
          button.disabled = false;
        }
      }
    });
  });
});

// Menú móvil Realza: abre el panel lateral y permite cerrarlo sin afectar el menú de escritorio.
document.addEventListener('DOMContentLoaded', () => {
  const openButtons = document.querySelectorAll('[data-mobile-menu-open]');
  const closeButtons = document.querySelectorAll('[data-mobile-menu-close]');
  const panel = document.getElementById('MobileMenuRealza');

  const setMobileMenuState = isOpen => {
    document.body.classList.toggle('mobile-menu-open', isOpen);
    if (panel) panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    openButtons.forEach(button => button.setAttribute('aria-expanded', isOpen ? 'true' : 'false'));
  };

  openButtons.forEach(button => {
    button.addEventListener('click', () => setMobileMenuState(true));
  });

  closeButtons.forEach(button => {
    button.addEventListener('click', () => setMobileMenuState(false));
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') setMobileMenuState(false);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const policyOpeners = document.querySelectorAll('[data-policy-open]');
  const policyClosers = document.querySelectorAll('[data-policy-close]');

  policyOpeners.forEach(button => {
    button.addEventListener('click', () => {
      document.body.classList.add('policy-open');
    });
  });

  policyClosers.forEach(button => {
    button.addEventListener('click', () => {
      document.body.classList.remove('policy-open');
    });
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.body.classList.remove('policy-open');
    }
  });
});

// Galería de producto: muestra todas las imágenes y permite abrirlas a detalle.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const images = Array.from(gallery.querySelectorAll('[data-gallery-image]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const modal = document.querySelector('[data-product-image-modal]');
    const modalImage = modal ? modal.querySelector('[data-product-modal-image]') : null;
    const modalCloseButtons = modal ? modal.querySelectorAll('[data-product-modal-close]') : [];

    const selectImage = index => {
      images.forEach(image => image.classList.toggle('is-active', image.dataset.mediaIndex === String(index)));
      thumbs.forEach(thumb => thumb.classList.toggle('is-active', thumb.dataset.mediaIndex === String(index)));
    };

    const openModal = imageButton => {
      if (!modal || !modalImage) return;
      const fullSrc = imageButton.dataset.fullSrc;
      const image = imageButton.querySelector('img');
      modalImage.src = fullSrc || (image ? image.src : '');
      modalImage.alt = image ? image.alt : '';
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('product-image-open');
    };

    const closeModal = () => {
      if (!modal) return;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('product-image-open');
      if (modalImage) modalImage.src = '';
    };

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => selectImage(thumb.dataset.mediaIndex));
    });

    images.forEach(imageButton => {
      imageButton.addEventListener('click', () => openModal(imageButton));
    });

    modalCloseButtons.forEach(button => button.addEventListener('click', closeModal));

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') closeModal();
    });
  });
});

// Botones desplegables de confianza: apertura limpia y comportamiento premium.
document.addEventListener('DOMContentLoaded', () => {
  const trustToggles = Array.from(document.querySelectorAll('[data-trust-toggle]'));

  trustToggles.forEach(details => {
    const summary = details.querySelector('summary');
    if (!summary) return;

    summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

    details.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

      if (details.open) {
        trustToggles.forEach(other => {
          if (other !== details && other.open) {
            other.open = false;
            const otherSummary = other.querySelector('summary');
            if (otherSummary) otherSummary.setAttribute('aria-expanded', 'false');
          }
        });
      }
    });
  });
});

// Filtro de material para que las subcategorías conserven su colección real.
// Ejemplo: /collections/cadenas?material=oro muestra solo cadenas de oro.
document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  const material = (params.get('material') || '').toLowerCase().trim();

  if (!['oro', 'plata'].includes(material)) return;

  const grid = document.querySelector('[data-material-product-grid]');
  if (!grid) return;

  const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
  const emptyMessage = document.querySelector('[data-material-empty]');
  let visibleCards = 0;

  cards.forEach(card => {
    const materialTokens = (card.dataset.productMaterials || '')
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean);
    let isMatch = materialTokens.includes(material);

    // Si una pieza está marcada como oro, no debe mostrarse dentro del filtro plata,
    // aunque por error también esté dentro de una colección general llamada Plata.
    if (material === 'plata' && materialTokens.includes('oro')) {
      isMatch = false;
    }

    card.hidden = !isMatch;
    if (isMatch) visibleCards += 1;
  });

  if (emptyMessage) {
    emptyMessage.hidden = visibleCards !== 0;
  }
});
// Fade-in al hacer scroll - Realza Joyas
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.shopify-section');

  if (!('IntersectionObserver' in window)) {
    sections.forEach(section => section.classList.add('visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  sections.forEach(section => {
    section.classList.add('visible');
    observer.observe(section);
  });
});

// Limpieza global de texto accidental y navegación de categorías de Realza.
document.addEventListener('DOMContentLoaded', () => {
  const garbagePattern = /bjfghvgyrshgftfdsauytey543345\s*gr/gi;
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  while (walker.nextNode()) textNodes.push(walker.currentNode);
  textNodes.forEach(node => {
    const value = node.nodeValue || '';
    if (garbagePattern.test(value)) node.nodeValue = value.replace(garbagePattern, '').trim();
    garbagePattern.lastIndex = 0;
  });

  const hiddenCategoryHandles = new Set([
    'coquetas','anillos','dijes','broqueles','aretes','tobilleras','rosarios'
  ]);
  const hiddenChainSubtypeHandles = new Set([
    'cadena-tejido-torzal-figaro-italiano',
    'cadena-tejido-figaro-3y1-italiana',
    'cadena-tejido-torzal-hueco'
  ]);
  const getCollectionHandle = href => {
    try {
      const match = new URL(href, window.location.origin).pathname.match(/^\/collections\/([^/]+)/);
      return match ? match[1].toLowerCase() : '';
    } catch (_) { return ''; }
  };

  document.querySelectorAll('.site-header a[href*="/collections/"]').forEach(link => {
    const handle = getCollectionHandle(link.getAttribute('href'));
    if (hiddenCategoryHandles.has(handle)) {
      const desktopGroup = link.closest('.header-dropdown-group');
      const mobileNested = link.closest('.mobile-menu-nested');
      if (desktopGroup) desktopGroup.hidden = true;
      else if (mobileNested) mobileNested.hidden = true;
      else link.hidden = true;
    }
    if (hiddenChainSubtypeHandles.has(handle)) link.hidden = true;
  });
});

// Traducción permanente de las etiquetas visibles de Judge.me.
// Las opiniones y la cantidad de reseñas continúan siendo datos reales.
(() => {
  const translatePhrase = value => {
    const normalized = String(value || '').replace(/\s+/g, ' ').trim();
    if (!normalized) return '';

    const exact = {
      'Customer Reviews': 'Opiniones de clientes',
      'Write a review': 'Escribir una reseña',
      'No reviews yet': 'Aún no hay opiniones',
      'Be the first to write a review': 'Sé la primera persona en escribir una reseña',
      '1 review': '1 opinión',
      'Sort by': 'Ordenar por',
      'Most Recent': 'Más recientes',
      'Highest Rating': 'Mejor calificación',
      'Lowest Rating': 'Menor calificación',
      'Pictures First': 'Con fotos primero',
      'Submit Review': 'Enviar reseña',
      'Review Title': 'Título de la opinión',
      'Name': 'Nombre',
      'Email': 'Correo electrónico',
      'Rating': 'Calificación',
      'Review': 'Opinión',
      'Cancel': 'Cancelar'
    };

    if (exact[normalized]) return exact[normalized];

    let match = normalized.match(/^Based on 1 review$/i);
    if (match) return 'Basado en 1 opinión';

    match = normalized.match(/^Based on (\d+) reviews$/i);
    if (match) return `Basado en ${match[1]} opiniones`;

    match = normalized.match(/^(\d+) reviews$/i);
    if (match) return `${match[1]} opiniones`;

    return '';
  };

  const replaceElementText = element => {
    if (!element) return;
    const translated = translatePhrase(element.textContent);
    if (translated && element.textContent.trim() !== translated) {
      element.textContent = translated;
    }
  };

  const translateJudgeMe = () => {
    // Selectores directos para las tres etiquetas principales.
    document.querySelectorAll('.jdgm-rev-widg__title').forEach(element => {
      element.textContent = 'Opiniones de clientes';
    });

    document.querySelectorAll(
      '.jdgm-rev-widg__summary-text, .jdgm-all-reviews-text, .jdgm-rev-widg__summary'
    ).forEach(element => {
      const translated = translatePhrase(element.textContent);
      if (translated) element.textContent = translated;
    });

    document.querySelectorAll(
      '.jdgm-write-rev-link, .jdgm-write-rev-link.jdgm-write-rev-link, [class*="jdgm-write-rev"]'
    ).forEach(replaceElementText);

    // Respaldo para cualquier otra etiqueta que Judge.me inserte después.
    document.querySelectorAll(
      '#judgeme_product_reviews, .jdgm-widget, [class*="jdgm-"]'
    ).forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);

      nodes.forEach(node => {
        const original = (node.nodeValue || '').trim();
        const translated = translatePhrase(original);
        if (translated && original !== translated) {
          node.nodeValue = (node.nodeValue || '').replace(original, translated);
        }
      });
    });
  };

  const startJudgeMeTranslation = () => {
    let scheduled = false;

    const scheduleTranslation = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        translateJudgeMe();
      });
    };

    translateJudgeMe();

    // Judge.me puede cargar o volver a dibujar el módulo después del contenido.
    const observer = new MutationObserver(scheduleTranslation);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    window.addEventListener('load', translateJudgeMe);
    window.setTimeout(translateJudgeMe, 1000);
    window.setTimeout(translateJudgeMe, 3000);
    window.setTimeout(translateJudgeMe, 7000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startJudgeMeTranslation, { once: true });
  } else {
    startJudgeMeTranslation();
  }
})();
